import { store } from '@atredux/store'
import { setIsSeawardFrameLoading, setSeawardProvisionError, seawardIFrameLoadingStatus } from '@atredux/slices/iframeSlice'

export async function seawardSetupErrorListener (exception) {
    console.log('ATBase: Received seaward frame setup confirmation')
    store.dispatch(setSeawardProvisionError(exception.data.cause ?? exception.data.message))
    store.dispatch(setIsSeawardFrameLoading(seawardIFrameLoadingStatus.FAILED))
    return true
}
